import { createReducer } from 'redux-act';
import * as actions from '#app/actions/coupon';
import type { CouponFormPayload } from '#app/actions/coupon';

interface CouponState {
  modalVisible: boolean;
  form: Record<string, unknown>;
}

const initialState: CouponState = {
  modalVisible: false,
  form: {},
};

const setCouponModalVisible = (state: CouponState, bool: boolean): CouponState => ({
  ...state,
  modalVisible: bool,
});

const setCouponForm = (state: CouponState, form: CouponFormPayload): CouponState => ({
  ...state,
  form: form ?? {},
});

const closeCouponForm = (state: CouponState): CouponState => ({
  ...state,
  form: {},
  modalVisible: false,
});

export default createReducer<CouponState>(
  {
    [actions.setCouponModalVisible.getType()]: setCouponModalVisible,
    [actions.setCouponForm.getType()]: setCouponForm,
    [actions.closeCouponForm.getType()]: closeCouponForm,
  },
  initialState
);
